import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const BankView = () => {
  const { id } = useParams();
  const [bank, setBank] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Http.get(`/accounts/banks/${id}`)
      .then((res) => {
        setBank(res.data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Bank Details</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Bank Information</h6>
            
            {loading ? (
              <ProgressSpinner />
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <tbody>
                    <tr>
                      <th width="200">Bank Name</th>
                      <td>{bank.name}</td>
                    </tr>
                    <tr>
                      <th>Account Number</th>
                      <td>{bank.account_number}</td>
                    </tr>
                    <tr>
                      <th>Branch</th>
                      <td>{bank.branch}</td>
                    </tr>
                    <tr>
                      <th>Balance</th>
                      <td>{bank.balance}</td>
                    </tr>
                    {/* <tr>
                      <th>Description</th>
                      <td>{bank.description}</td>
                    </tr> */}
                    <tr>
                      <th>Status</th>
                      <td>
                        {bank.status === "Active" ? (
                          <span className="badge badge-success">Active</span>
                        ) : (
                          <span className="badge badge-danger">Inactive</span>
                        )}
                      </td>
                    </tr>
                    {/* <tr>
                      <th>Created At</th>
                      <td>{new Date(bank.created_at).toLocaleString()}</td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>{new Date(bank.updated_at).toLocaleString()}</td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankView;